/* eslint-disable camelcase */
import SalesAnalysisColumnDefinitionFactory from '@/app/sales_analysis/models/SalesAnalysisColumnDefinitionFactory'

export default class SalesAnalysisAgGrid {
  constructor ({ col_definition, data, aggregation }) {
    this.columnDefs = col_definition.map((columnDef) => SalesAnalysisColumnDefinitionFactory.create(columnDef))
    this.data = data
    this.aggregation = [{ ...aggregation, pivot: ' ' }]
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/SalesAnalysisAgGrid.js